<main class="main-content mx-3">
  <router-outlet></router-outlet>
</main>
  